import { makeAutoObservable, observable, action } from 'mobx';

class OnlineService {
  @observable isOnline: boolean = typeof navigator !== 'undefined' ? navigator.onLine : true;

  constructor() {
    if (typeof window !== 'undefined') {
      makeAutoObservable(this);
      window.addEventListener('online', this._onOnline);
      window.addEventListener('offline', this._onOffline);
    }
  }

  @action
  private _onOnline = () => {
    this.isOnline = true;
  };

  @action
  private _onOffline = () => {
    this.isOnline = false;
  }
}

export const onlineService = new OnlineService();
